import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDigitOnly]',
  standalone: true,
})
export class DigitOnlyDirective {
  private readonly control = inject(NgControl);
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const value = input.value.replace(/\D/g, '');

    const formatted = value.substring(0, 3);

    input.value = formatted;

    this.control.control?.setValue(formatted, {
      emitEvent: false,
      emitModelToViewChange: false,
    });
  }
}
